<script lang="ts">
    import { tick } from 'svelte';

    interface Props {
        isIOSApp: boolean;
        useUniversalScrollRestore: boolean;
        cacheRestored: boolean;
        restoreScrollPosition: () => Promise<void>;
        saveScrollSelector: () => void;
    }

    const { isIOSApp, useUniversalScrollRestore, cacheRestored, restoreScrollPosition, saveScrollSelector }: Props =
        $props();

    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    $effect(() => {
        if (useUniversalScrollRestore) {
            window.history.scrollRestoration = 'manual';

            let scrollDebounceId: ReturnType<typeof setTimeout> | undefined;

            function handleScroll() {
                clearTimeout(scrollDebounceId);
                scrollDebounceId = setTimeout(saveScrollSelector, 150);
            }

            function handleVisibilityChange() {
                if (document.visibilityState === 'hidden') {
                    clearTimeout(scrollDebounceId);
                    saveScrollSelector();
                }
            }

            window.addEventListener('scroll', handleScroll, { passive: true });
            document.addEventListener('visibilitychange', handleVisibilityChange);

            if (cacheRestored) {
                tick().then(() => {
                    if (isIOSApp) {
                        timeoutId = setTimeout(restoreScrollPosition, 250);
                    } else {
                        void restoreScrollPosition();
                    }
                });
            }

            return () => {
                window.history.scrollRestoration = 'auto';
                window.removeEventListener('scroll', handleScroll);
                document.removeEventListener('visibilitychange', handleVisibilityChange);
                clearTimeout(scrollDebounceId);
                if (timeoutId !== undefined) {
                    clearTimeout(timeoutId);
                    timeoutId = undefined;
                }
            };
        }

        /*                                                                      */
        if (isIOSApp) {
            window.history.scrollRestoration = 'manual';
            if (cacheRestored) {
                tick().then(() => {
                    timeoutId = setTimeout(restoreScrollPosition, 250);
                });
            }
            return () => {
                window.history.scrollRestoration = 'auto';
                if (timeoutId !== undefined) {
                    clearTimeout(timeoutId);
                    timeoutId = undefined;
                }
            };
        }
    });
</script>
